import { render } from "./mirrorIntro.vue?vue&type=template&id=1db36afb&scoped=true"
import script from "./mirrorIntro.vue?vue&type=script&lang=js"
export * from "./mirrorIntro.vue?vue&type=script&lang=js"

import "./mirrorIntro.vue?vue&type=style&index=0&id=1db36afb&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db36afb"]])

export default __exports__